import api  from './api';

const API_URL = '/budget';

export const getCostoDiCostruzione = async (cantiereId) => {
  const res = await api.get(`${API_URL}/costo-di-costruzione/${cantiereId}`);
  return res.data;
};

export const saveCostoDiCostruzione = async (cantiereId, dati) => {
  const res = await api.post(`${API_URL}/costo-di-costruzione/${cantiereId}`, dati);
  return res.data;
};